import type { Routes } from '@angular/router';

export const PLATFORMS_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'connection',
        pathMatch: 'full',
    },
    {
        path: 'connection',
        loadComponent: () =>
            import('#modules/platforms/views/platforms-root/platforms-root.component').then((m) => m.PlatformsRootComponent),
    },
];
